// Hardcoded default trail start: 7:00 PM Eastern. Until Milestone 4 makes the
// time configurable per trail, every trail starts at 7pm in America/New_York,
// and the migration backfills the same for existing date-only trails. Using the
// IANA zone (not a fixed offset) keeps it DST-correct — summer trails resolve to
// EDT (-04:00), winter trails to EST (-05:00).
export const DEFAULT_TRAIL_TIME = "19:00";
export const DEFAULT_TRAIL_TIME_ZONE = "America/New_York";
/**
 * Build a full ISO 8601 instant *with offset* (e.g. "2026-05-20T19:00:00-04:00")
 * for a wall-clock (`date`, "HH:mm") in an IANA `timeZone`. Defaults to 7pm
 * Eastern. Returns null if the inputs don't parse.
 *
 * No date library: make a UTC guess for the wall-clock fields, ask Intl what
 * that instant reads as in the target zone vs UTC, and the gap is the zone's
 * offset at that date — DST-correct for the trail's own day.
 */
export function trailStartAt(date, time = DEFAULT_TRAIL_TIME, timeZone = DEFAULT_TRAIL_TIME_ZONE) {
    const [y, m, d] = date.split("-").map(Number);
    const [hh, mm] = time.split(":").map(Number);
    if ([y, m, d, hh, mm].some((n) => !Number.isFinite(n)))
        return null;
    const utcGuess = Date.UTC(y, m - 1, d, hh, mm);
    const guess = new Date(utcGuess);
    const asZone = new Date(guess.toLocaleString("en-US", { timeZone }));
    const asUtc = new Date(guess.toLocaleString("en-US", { timeZone: "UTC" }));
    // Minutes the zone is offset from UTC at this instant (NY in June => -240).
    const offsetMin = -(asUtc.getTime() - asZone.getTime()) / 60000;
    const sign = offsetMin >= 0 ? "+" : "-";
    const abs = Math.abs(offsetMin);
    const pad = (n) => String(n).padStart(2, "0");
    return `${date}T${pad(hh)}:${pad(mm)}:00${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
}
